import { runYouhuiquanCreate } from "@/script/youhuiquanCreateRunner";

// 优惠券页面状态（表单/进度放 Vuex，切换菜单不丢失）
const state = {
    yhq_form: {
        channel_key: "public", // public|live|kefu|coupon_center|private
        goods_scope: 2, // 1 指定商品 2 全店
        discount_kind: "reduce", // reduce|threshold|discount
        credit_yuan: 1, // 立减/满减减免（元）
        threshold_yuan: 100, // 满减门槛（元）
        discount_zhe: 9.9, // 折扣（折）
        period_mode: "same", // same|days|custom
        valid_days: 7,
        renew_switch_on: false,
        title_mode: "default", // default|prefix
        title_prefix: "",
        stock_mode: "unlimited", // unlimited|limited
        total_amount: 10000,
        user_limit_mode: "unlimited", // unlimited|limited
        max_apply_times: 3,
        live_coupon_duration: 30, // 看播秒数
        live_valid_minutes: 30, // 领取后有效分钟
    },
    yhq_selected_shop_ids: [],
    yhq_apply_range: null, // 领取时间 [startMs, endMs]
    yhq_use_range: null, // 自定义使用时间 [startMs, endMs]

    // 指定商品
    yhq_products: [],
    yhq_product_selects: [],
    yhq_load_running: false,
    yhq_load_status_text: "",
    yhq_load_stop_flag: false,

    // 创建进度
    yhq_create_running: false,
    yhq_create_stop_requested: false,
    yhq_create_dialog: false,
    yhq_create_total: 0,
    yhq_create_done: 0,
    yhq_create_success: 0,
    yhq_create_fail: 0,
    yhq_create_results: [],

    // 活动管理
    yhq_manage_rows: [],
    yhq_manage_loading: false,
    yhq_manage_stop_flag: false,
    yhq_manage_page_info: "",
};

const mutations = {
    setYhqForm(state, patch) {
        Object.assign(state.yhq_form, patch || {});
    },
    setYhqSelectedShopIds(state, ids) {
        state.yhq_selected_shop_ids = ids || [];
    },
    setYhqApplyRange(state, range) {
        state.yhq_apply_range = range;
    },
    setYhqUseRange(state, range) {
        state.yhq_use_range = range;
    },
    setYhqProducts(state, rows) {
        state.yhq_products = rows || [];
    },
    appendYhqProducts(state, rows) {
        if (Array.isArray(rows) && rows.length) {
            state.yhq_products = state.yhq_products.concat(rows);
        }
    },
    setYhqProductSelects(state, keys) {
        state.yhq_product_selects = keys || [];
    },
    setYhqLoadRunning(state, v) {
        state.yhq_load_running = !!v;
    },
    setYhqLoadStatusText(state, v) {
        state.yhq_load_status_text = v || "";
    },
    setYhqLoadStopFlag(state, v) {
        state.yhq_load_stop_flag = !!v;
    },
    setYhqCreateRunning(state, v) {
        state.yhq_create_running = !!v;
    },
    setYhqCreateStopRequested(state, v) {
        state.yhq_create_stop_requested = !!v;
    },
    setYhqCreateDialog(state, v) {
        state.yhq_create_dialog = !!v;
    },
    yhqCreateStart(state, total) {
        state.yhq_create_total = total;
        state.yhq_create_done = 0;
        state.yhq_create_success = 0;
        state.yhq_create_fail = 0;
        state.yhq_create_results = [];
    },
    yhqCreateProgress(state, { done = 0, success = 0, fail = 0 }) {
        state.yhq_create_done += done;
        state.yhq_create_success += success;
        state.yhq_create_fail += fail;
    },
    yhqCreateResultPush(state, rows) {
        if (Array.isArray(rows) && rows.length) {
            const base = state.yhq_create_results.length;
            const stamped = rows.map((r, i) => ({
                _rowId: `yhqres_${Date.now()}_${base + i}_${Math.random()
                    .toString(36)
                    .slice(2, 8)}`,
                ...r,
            }));
            state.yhq_create_results = state.yhq_create_results.concat(stamped);
        }
    },
    setYhqManageRows(state, rows) {
        state.yhq_manage_rows = rows || [];
    },
    appendYhqManageRows(state, rows) {
        if (Array.isArray(rows) && rows.length) {
            state.yhq_manage_rows = state.yhq_manage_rows.concat(rows);
        }
    },
    yhqManagePatchRow(state, { _rowId, patch }) {
        const row = state.yhq_manage_rows.find((r) => r._rowId === _rowId);
        if (row && patch) Object.assign(row, patch);
    },
    setYhqManageLoading(state, v) {
        state.yhq_manage_loading = !!v;
    },
    setYhqManageStopFlag(state, v) {
        state.yhq_manage_stop_flag = !!v;
    },
    setYhqManagePageInfo(state, v) {
        state.yhq_manage_page_info = v || "";
    },
};

const actions = {
    async yhqRunCreate({ state, commit }, { shopList }) {
        if (state.yhq_create_running) return;
        commit("setYhqCreateRunning", true);
        commit("setYhqCreateStopRequested", false);
        commit("setYhqCreateDialog", true);
        try {
            await runYouhuiquanCreate({ state, commit, shopList });
        } finally {
            commit("setYhqCreateRunning", false);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
